/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Component } from 'react';
import PropTypes from 'prop-types';
import InformationBoxComponent from '../../shared_components/InformationBoxComponent';

class OverviewTableSortingHeadComponent extends Component {
  constructor(props) {
    super(props);

    this.showTextBox = this.showTextBox.bind(this);
  }

  showTextBox(data, event) {
    event.stopPropagation();
    this.props.ModalData.openModal(data);
  }

  render() {
    const {
      sortedOverviewTableColumn,
      firstOverviewTableColumnFixedRateTerm,
      sortLabelInterestsByInitialInterest,
      sortedClassName,
      informationBoxData,
      sortLabelInterestsByTermInterest,
      secondOverviewTableColumnFixedRateTerm,
      sortLabelInterestsByTermInterestAvailable,
    } = this.props;

    return (
      <thead>
        <tr>
          <th colSpan={2}>Verstrekker</th>
          <th
            className={sortedOverviewTableColumn === `initialInterest-${firstOverviewTableColumnFixedRateTerm}` ?
                sortedClassName : ''}
            onClick={() => {
              sortLabelInterestsByInitialInterest(firstOverviewTableColumnFixedRateTerm);
            }}
          >
          Aanvangsrente
          <InformationBoxComponent
            classNames="info-box-static"
            onClickHandler={(event) => { this.showTextBox(informationBoxData.initialInterest, event); }}
          />
          </th>
          <th
            className={sortedOverviewTableColumn === `averageInterest-${firstOverviewTableColumnFixedRateTerm}` ?
                sortedClassName : ''}
            onClick={() => {
              sortLabelInterestsByTermInterest(firstOverviewTableColumnFixedRateTerm);
            }}
          >
          Looptijdrente
          <InformationBoxComponent
            classNames="info-box-static"
            onClickHandler={(event) => { this.showTextBox(informationBoxData.looptijdRente, event); }}
          />
          </th>
          <th
            className={sortedOverviewTableColumn === `initialInterest-${secondOverviewTableColumnFixedRateTerm}` ?
                sortedClassName : ''}
            onClick={() => {
              sortLabelInterestsByInitialInterest(secondOverviewTableColumnFixedRateTerm);
            }}
          >
          Aanvangsrente
          <InformationBoxComponent
            classNames="info-box-static"
            onClickHandler={(event) => { this.showTextBox(informationBoxData.initialInterest, event); }}
          />
          </th>
          <th
            className={sortedOverviewTableColumn === `averageInterest-${secondOverviewTableColumnFixedRateTerm}` ?
                sortedClassName : ''}
            onClick={() => {
              sortLabelInterestsByTermInterest(secondOverviewTableColumnFixedRateTerm);
            }}
          >
          Looptijdrente
          <InformationBoxComponent
            classNames="info-box-static"
            onClickHandler={(event) => { this.showTextBox(informationBoxData.looptijdRente, event); }}
          />
          </th>
          <th
            className={sortedOverviewTableColumn === 'averageInterestAvailable' ? sortedClassName : ''}
            onClick={() => {
              sortLabelInterestsByTermInterestAvailable();
            }} colSpan={3}
          >
          Looptijdrente
          <InformationBoxComponent
            classNames="info-box-static"
            onClickHandler={(event) => { this.showTextBox(informationBoxData.looptijdRenteYesNo, event); }}
          />
          </th>
          <th />
        </tr>
      </thead>
    );
  }
}

OverviewTableSortingHeadComponent.propTypes = {
  sortedOverviewTableColumn: PropTypes.string,
  firstOverviewTableColumnFixedRateTerm: PropTypes.number,
  sortLabelInterestsByInitialInterest: PropTypes.func,
  sortedClassName: PropTypes.string,
  informationBoxData: PropTypes.shape({}),
  sortLabelInterestsByTermInterest: PropTypes.func,
  secondOverviewTableColumnFixedRateTerm: PropTypes.number,
  sortLabelInterestsByTermInterestAvailable: PropTypes.func,
  ModalData: PropTypes.shape({
    openModal: PropTypes.func,
  }),
};

OverviewTableSortingHeadComponent.defaultProps = {
  sortedOverviewTableColumn: '',
  firstOverviewTableColumnFixedRateTerm: 0,
  sortLabelInterestsByInitialInterest: () => {},
  sortedClassName: '',
  informationBoxData: {},
  sortLabelInterestsByTermInterest: () => {},
  secondOverviewTableColumnFixedRateTerm: 0,
  sortLabelInterestsByTermInterestAvailable: () => {},
  ModalData: {
    openModal: () => {},
  },
};

export default OverviewTableSortingHeadComponent;
